const initialState = {
  Token: {
    Value: "",
    Guid: "",
    AlaskaLoyaltyNumber: "",
  },
  MileagePlanDetails: {
    MemberFullName: "",
    LoyaltyNumber: "",
    MemberBalance: 0,
    TierName: "",
    TierCode: "",
    FraudAlertFlag: false,
    // AB#1648734: true when the signed-in account is a business's own Mileage
    // Plan account (LMS member type EASYBIZ, surfaced by mpactivityBffApi
    // GET member/data as `isEasyBiz`). Distinct from the AFB cookie, which
    // marks an individual traveller browsing a business profile.
    IsEasyBiz: false,
    IsLoaded: false,
  },
  MileagePlanActivity: [
    {
      Date: "10/20/2007",
      Activity: "",
      Bonus: 0,
      "Bonus Points": 10,
      Status: "",
      "Total Points": 0,
    },
  ],
  // Choice-Based Accruals: the member's current earn method, sourced from
  // loyaltymembership-middleware-functions' GET /status (accrualMethod field:
  // "REVENUE" | "DISTANCE" | "SEGMENT" | null). Per that team, there is no
  // eligibility/hasMadeChoice flag. MPDataService.getCbaAccrualInfo defaults a
  // successful-but-empty response to "REVENUE" (matches accountoverview's
  // DEFAULT_ACCRUAL_METHOD), so this stays `null` only before the fetch
  // resolves or when the fetch itself fails - both of which hide the banner.
  CbaAccrualInfo: {
    AccrualMethod: null as string | null,
  },
  isSuperUser: false,
  Error: { message: null },
};

export type AccountStateType = typeof initialState;

export default initialState;
